import { makeStyles } from '@material-ui/styles';
import { pulse, fadeInDelay } from '../../animation/AnimationUtils';

export const suggestionsZIndex = 4;

export default makeStyles(() => ({
    rootWrapper: {
        position: 'relative',
        zIndex: suggestionsZIndex,
    },
    options: {
        position: 'absolute',
        left: '0',
        width: '100%',
        margin: '0',
        zIndex: '4',
        maxHeight: '288px',
        overflowY: 'scroll',
        overflowX: 'hidden',
        ...fadeInDelay(50),
        animationDuration: '100ms',
        marginBottom: '30px',
    },
    emptyResult: {
        padding: '20px',
        fontSize: '15px',
        textAlign: 'center',
    },
}));

export const useLoadingStyle = makeStyles(() => ({
    root: {
        width: () => `${120 + Math.floor(Math.random() * (100)) + 50}px`,
        height: '30px',
        ...pulse(),
    },
}));
